(window.aeOnSectionReady || function (fn) { document.addEventListener('DOMContentLoaded', () => fn(document)); })((sectionRoot) => {
  document.querySelectorAll('[data-ae-footer-accordion]').forEach((wrapper) => {
    if (wrapper.dataset.aeBound === 'true') return;
    wrapper.dataset.aeBound = 'true';
    const singleOpen = wrapper.dataset.singleOpen !== 'false';
    const items = Array.from(wrapper.querySelectorAll('.ae-footer__menu-column'));
    const mq = window.matchMedia('(min-width: 990px)');

    const applyViewport = () => {
      if (mq.matches) {
        items.forEach((item) => { item.open = true; });
      }
    };

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (mq.matches) {
          if (!item.open) item.open = true;
          return;
        }
        if (!singleOpen || !item.open) return;
        items.forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });

    applyViewport();
    if (mq.addEventListener) mq.addEventListener('change', applyViewport);
    else if (mq.addListener) mq.addListener(applyViewport);
  });
});
